export enum FirstLoginStepEnum {
  INTRO = 'intro',
  USER_METRICS = 'userMetrics',
  NO_RESULTS_RATIO = 'noResultsRatio',
  CHECKOUT_RATIO = 'checkoutRatio',
  QUERIES_DISTRIBUTION = 'queriesDistribution',
  GLOBAL_QUERIES = 'globalQueries',
  COMPARISON_PERIODS = 'comparisonPeriods',
  MULTISELECTABLE_FILTERS = 'multiselectableFilters'
}
